import React from 'react';

const ChevronLeft = ({ width = 24, height = 24 }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={width} height={height} aria-hidden="true">
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
  </svg>
);

export default ChevronLeft;
